import Config from '@config';
import { normalizeInfiniteQueryData } from '@gasbi/shared/common/features/utils';
import { createApi } from '@reduxjs/toolkit/query/react';

import { Pagination } from '@/features/types';
import { infiniteQueryOptions } from '@/features/utils';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

import './mocks/mockApi';
import { ConsumerDocuments, ConsumerDocumentsParams } from './types';

const tagTypes = ['ConsumerDocuments', 'ConsumerDocument'];

export const consumerDocumentsApi = createApi({
  reducerPath: 'consumerDocumentsApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${Config.VITE_API_URL}/consumer-documents`,
  }),
  tagTypes,
  endpoints: builder => ({
    getConsumerDocuments: builder.query<
      ConsumerDocuments[],
      ConsumerDocumentsParams
    >({
      query: params => ({
        url: `/query`,
        params,
      }),
      providesTags: ['ConsumerDocuments'],
    }),
    getConsumerDocumentsI: builder.infiniteQuery<
      ConsumerDocuments[],
      ConsumerDocumentsParams,
      Pagination
    >({
      infiniteQueryOptions,
      query: ({ queryArg, pageParam }) => ({
        url: '/query',
        params: { ...queryArg, ...pageParam },
      }),
      providesTags: () => ['ConsumerDocuments', 'ConsumerDocument'],
    }),
  }),
});

export const useGetConsumerDocumentsIInfiniteQuery = normalizeInfiniteQueryData(
  consumerDocumentsApi.useGetConsumerDocumentsIInfiniteQuery,
);
